import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutNavbarProps } from './types';
import Navbar from '../Navbar';
import Icon from '../Icon';
import './index.less';

const LayoutNavbar = ({
  children,
  navbarProps,
  containerStyle,
  className = '',
  isHomeIcon = true,
}: LayoutNavbarProps) => {
  return (
    <div className={`layout-navbar ${className}`}>
      <Navbar {...navbarProps}>
        {isHomeIcon && (
          <Link to="/" className="area-enhance-large">
            <Icon color="#585f66" type="btn_back_subscribe" />
          </Link>
        )}
      </Navbar>
      <div className="layout-navbar-container" style={containerStyle}>
        {children}
      </div>
    </div>
  );
};

export default LayoutNavbar;
